export default class Currency {
  private _value!: number | undefined;
  private _displayValue!: string;

  set value(value: number | string | undefined | null) {
    // Set the values if a number is entered
    if (typeof value === 'number') {
      this._value = isNaN(value) ? undefined : value;
      this._displayValue = value.toLocaleString(undefined, {
        maximumFractionDigits: 2,
      });
      return;
    }

    // If value is empty or invalid string
    if ( typeof value !== 'string' || value.trim().match(/^-?\.?$/) ) {
      this._value = undefined;
      this._displayValue = typeof value === 'string' ? value.trim() : '';
      return;
    }

    // Clean the string
    let cleanValue: string;
    const splitValue = value.split('.');

    if (splitValue.length === 1) {
      // No decimal part
      cleanValue = value.replace(/[^\d-]/g, '');
    } else {
      // Decimal part exists, keep only 2 digits
      const intPart = splitValue[0].replace(/[^\d-]/g, '');
      const decPart = splitValue[1].replace(/[^\d]/g, '').substr(0, 2);
      cleanValue = intPart + '.' + decPart;
    }

    // Preserve exact input if it ends with '.' or has up to 2 decimal digits
    const trailing = cleanValue.match(/(\.\d{0,2})$/);
    if (trailing) {
      this._value = Number(cleanValue);
      // Format the integer part with commas while preserving the decimal part as-is
      const intPart = cleanValue.substring(0, cleanValue.indexOf('.'));
      const decPart = cleanValue.substring(cleanValue.indexOf('.'));
      const formattedInt = Number(intPart).toLocaleString();
      this._displayValue = formattedInt + decPart;
      return;
    }

    // Fallback / normal behavior
    this._value = Number(cleanValue);
    if (isNaN(this._value)) this._value = 0;
    this._displayValue = this._value.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  get value(): number | string | undefined | null {
    return this._value;
  }

  get displayValue(): string {
    return this._displayValue;
  }

  constructor(value?: string | null) {
    this.value = value;
  }
}
